export default __webpack_public_path__ + "images/cdb20f15e8401e45b31bc96e9c578049.png";